<template>
  <PageLayout
    :is-loading="isLoading"
    page-title="Beranda"
    :show-notification="true"
    notification-text="Selamat untuk para Pointers of the Month!"
    notification-button-text="Lihat Disini"
    :show-banner="true"
    :banner-items="bannerItems"
    :show-sponsors="true"
    sponsor-title="Sponsor Hadiah Bert Points"
    @notification-click="viewDetails"
    @banner-click="handleBannerClick"
  >
    <!-- Campaign Section -->
    <!-- <div class="campaign-section">
      <div class="section-header">
        <h3 class="section-title">Campaign Bulan Ini</h3>
        <router-link to="/user/campaign" class="view-all-link">
          Lihat Lainnya <i class="mdi mdi-arrow-right"></i>
        </router-link>
      </div>
      <div class="campaign-list">
        <div v-for="(campaign, index) in campaigns" :key="index" class="campaign-item">
          <div class="campaign-image-box">
            <img :src="campaign.image || require('@/assets/berts-logo-header.png')" />
          </div>
          
          <div class="campaign-details">
            <div class="camp-category">{{ campaign.category }}</div>
            <h4 class="camp-title">{{ campaign.title }}</h4>
            <div class="camp-meta">
              <div>Waktu Registrasi: {{ formatDate(campaign.date) }}</div>
              <div>Dibutuhkan: {{ campaign.participants }} Influencers</div>
            </div>
          </div>
          
          <div class="campaign-points">
            <div class="points-box">
              <span class="p-val">{{ campaign.points }}</span>
              <span class="p-label">Points</span>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </PageLayout>
</template>

<script>
import AppPageLayout from '@/components/ui/PageLayout.vue';

export default {
  name: "HomeUser",
  components: { 
    PageLayout: AppPageLayout
  },
  data() {
    return {
      isLoading: false,
      bannerItems: [],
      campaigns: [] 
    };
  },
  methods: {
    fetchUserData() {},
    getPoint() {},
    loadBanners() {
      const baseURI = this.$settings.endPoint + "get-banner";
      this.isLoading = true;
      return this.$http
        .get(
          baseURI +
          `?limit=10&page=1&sort_field=&sort_type=&title=&link=&priority=&location=home`,
          {
            timeout: 10000,
            'headers': {
              'AppToken': this.$settings.jwtSecret,
            }
          }
        )
        .then((response) => {
          this.isLoading = false;
          this.bannerItems = response.data.datas;
        }).catch(error => {
          this.isLoading = false;
          console.log('Error:', error);
          this.handleError(error);
        });
    },
    
    loadCampaigns() {
      this.campaigns = [
        { id: 1, title: "Nama Campaign 1", category: "Lifestyle", date: "2024-07-10", participants: 20, points: 200, image: null },
        { id: 2, title: "Nama Campaign 1", category: "Mom & Baby", date: "2024-07-10", participants: 20, points: 200, image: null }
      ];
    },
    
    viewDetails() { 
      this.$router.push('/user/pointers-of-the-month'); 
    },
    
    handleBannerClick(banner) {
      console.log('Banner clicked:', banner);
      // Handle banner click - could navigate or open modal
      if (banner.link && banner.link !== '#') {
        window.open(banner.link, '_blank');
      }
    },
    
    formatDate() {
      return "10 Juli 2024"; 
    },
    
    handleError(error) {
      if (error.response) {
        if (error.response.status === 422) {
          console.error('Validation error:', error.response.data.errors);
        } else if (error.response.status === 500) {
          this.$router.push('/server-error');
        } else if (error.response.status === 401) {
          this.$router.push("/authorized-error");
        } else {
          this.$router.push('/page-not-found');
        }
      }
    },
    loading() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 1000);
    }
  },
  mounted() {
    this.loadCampaigns();
    this.loadBanners();
    this.loading();
  }
};
</script>

<style scoped>
/* ========================================= */
/* CAMPAIGN SECTION STYLES                   */
/* ========================================= */
.campaign-section {
  padding: 24px 32px;
  margin: 0 auto 32px auto;
  background: white;
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  max-width: 1200px;
  width: calc(100% - 64px); /* 32px margin on each side */
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.section-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #111827;
  margin: 0;
}

.view-all-link {
  color: #F2994A;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: color 0.3s ease;
}

.view-all-link:hover {
  color: #e0874a;
}

.campaign-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.campaign-item {
  display: flex;
  align-items: center;
  padding: 20px;
  border: 1px solid #EAECF0;
  border-radius: 12px;
  background: #fff;
  transition: box-shadow 0.2s, transform 0.2s;
}

.campaign-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.campaign-image-box {
  width: 100px;
  height: 100px;
  flex-shrink: 0;
  border-radius: 8px;
  background: #F3F4F6;
  overflow: hidden;
  margin-right: 20px;
}

.campaign-image-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.campaign-details {
  flex: 1;
}

.camp-category {
  font-size: 0.85rem;
  color: #9CA3AF;
  margin-bottom: 4px;
}

.camp-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1F2937;
  margin: 0 0 8px 0;
}

.camp-meta {
  font-size: 0.85rem;
  color: #6B7280;
  line-height: 1.4;
}

.campaign-points {
  margin-left: 16px;
}

.points-box {
  background-color: #4A90E2;
  color: white;
  padding: 10px 20px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 90px;
  text-align: center;
}

.p-val {
  font-weight: 700;
  font-size: 1.1rem;
  line-height: 1.1;
}

.p-label {
  font-size: 0.8rem;
  font-weight: 400;
}

/* ========================================= */
/* MOBILE RESPONSIVE STYLES                  */
/* ========================================= */
@media (max-width: 768px) {
  .campaign-section {
    width: calc(100% - 40px);
    margin: 0 20px 24px 20px;
    padding: 16px;
  }
  
  .section-header {
    margin-bottom: 16px;
  }
  
  .section-title {
    font-size: 1.1rem;
  }
  
  .view-all-link {
    font-size: 0.85rem;
  }

  .campaign-item {
    padding: 12px;
    flex-wrap: nowrap; 
    align-items: flex-start;
  }
  
  .campaign-image-box {
    width: 80px;
    height: 80px;
    margin-right: 12px;
  }
  
  .campaign-details {
    margin-right: 8px;
  }
  
  .camp-category {
    font-size: 0.75rem;
  }
  
  .camp-title { 
    font-size: 0.95rem; 
    margin-bottom: 4px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-clamp: 2;
  }
  
  .camp-meta {
    font-size: 0.75rem;
  }

  .campaign-points {
    margin-left: auto;
    flex-shrink: 0;
  }
  
  .points-box {
    padding: 6px 10px;
  }
  
  .p-val {
    font-size: 0.9rem;
  }
  
  .p-label {
    font-size: 0.7rem;
  }
}
</style>